var exports = {
  "Qq": "ChannelReplyBar.module__text___YlRsQ2",
  "Y_": "ChannelReplyBar.module__replyTargetButton___YlRsQ2",
  "fh": "ChannelReplyBar.module__authorName___YlRsQ2",
  "ne": "ChannelReplyBar.module__controls___YlRsQ2",
  "xS": "ChannelReplyBar.module__mentionToggle___YlRsQ2",
  "If": "ChannelReplyBar.module__mentionToggleOn___YlRsQ2",
  "G9": "ChannelReplyBar.module__mentionToggleOff___YlRsQ2",
  "mM": "ChannelReplyBar.module__mentionIcon___YlRsQ2",
  "b": "ChannelReplyBar.module__closeButton___YlRsQ2",
  "ut": "ChannelReplyBar.module__closeIcon___YlRsQ2",
};

module.exports = exports;
